// frontend/src/config/firebaseConfig.js

import { initializeApp } from 'firebase/app';
import { getFirestore, enableNetwork, disableNetwork } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { connectAuthEmulator } from 'firebase/auth';
import { connectFirestoreEmulator } from 'firebase/firestore';

const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDySZ0Aa_ZbSfG83XGMZenrLuZ_zz5UD5A",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "solicitudes-apos.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "solicitudes-apos",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "solicitudes-apos.appspot.com",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "97812285187",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:97812285187:web:d9b363f719d41b64160b36"
};

const firebaseApp = initializeApp(firebaseConfig);

export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);

if (useEmulators) {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, '127.0.0.1', 8082);
}

export const reconnectFirestore = async () => {
    try {
        console.log('Intentando reconectar a Firestore...');
        await disableNetwork(db);
        await enableNetwork(db);
        console.log('Reconexión a Firestore exitosa');
        return true;
    } catch (error) {
        console.error('Error al reconectar a Firestore:', error);
        return false;
    }
};

export default firebaseApp;
